import { useEffect, useState } from 'react';
import { ERROR_CODES } from '../../../core/constants';
import { useStore } from '../../../core/context/store/provider';
import { SimulatorStatus } from '../components/simulator/models';

type UseIsInstanceRunningOutput = {
  isInstanceRunning: boolean;
};

export const useIsInstanceRunning = (): UseIsInstanceRunningOutput => {
  const [isInstanceRunning, setIsInstanceRunning] = useState(true);
  const [simulatorStatusStore] = useStore<SimulatorStatus>('simulator-status');

  useEffect(() => {
    /**
     * We can't set isInstanceRunning to true once it has been set to false
     * due to simulator re-rendering resetting the error state
     */
    if (simulatorStatusStore.error === ERROR_CODES.INSTANCE_NOT_RUNNING_ERROR.toString()) {
      setIsInstanceRunning(false);
    }
  }, [simulatorStatusStore.error]);

  return { isInstanceRunning };
};
